import client from "./client";

const aiStudyApi = {
  // Onboarding - First-time setup (creates profile + auto-generates first week plan)
  onboarding(data) {
    return client
      .post("/ai-study/onboarding", data)
      .then((r) => r.data);
  },

  // Get current week's AI-generated study plan
  getCurrentPlan() {
    return client
      .get("/ai-study/plan/current")
      .then((r) => r.data);
  },

  // Manual plan regeneration (24hr cooldown)
  generatePlan() {
    return client
      .post("/ai-study/plan/generate")
      .then((r) => r.data);
  },

  // Timer actions
  startSlot(slotId) {
    return client
      .post(`/ai-study/slots/${slotId}/start`)
      .then((r) => r.data);
  },

  endSlot(slotId, actualMinutes) {
    return client
      .post(`/ai-study/slots/${slotId}/end`, actualMinutes ? { actualMinutes } : {})
      .then((r) => r.data);
  },

  skipSlot(slotId) {
    return client
      .patch(`/ai-study/slots/${slotId}/skip`)
      .then((r) => r.data);
  },

  // Quiz
  getQuiz(slotId) {
    return client
      .get(`/ai-study/slots/${slotId}/quiz`)
      .then((r) => r.data);
  },

  submitQuiz(slotId, answers) {
    return client
      .post(`/ai-study/slots/${slotId}/quiz/submit`, { answers })
      .then((r) => r.data);
  },

  // Legacy compatibility - redirects to new endpoints
  listStudySlots() {
    return this.getCurrentPlan();
  },
};

export default aiStudyApi;
